<template>
  <div class="container">
    <container :active_path="path"></container>
  </div>
</template>

<script>
import container from "../../components/container"
export default {
  components: {
    container,
  },
  data () {
    return {
      path: '/setting'
    }
  },
}
</script>


<style lang="scss" scoped>
</style>
